import { useParams } from 'react-router-dom'
import NavigationForm from './NavigationForm'

const View = () => {
    const params = useParams()

    return (
        <NavigationForm
            id={parseInt(params.navigationId)}
            inPopup={false}
            config={{
                submitSuccessMsg: {
                    header: 'Updated',
                    message: 'Navigation updated successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to update navigation',
                },
                saveButton: {
                    label: 'Update',
                    savingLabel: 'Updating navigation...',
                },
            }}
        />
    )
}

export default View
